import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  Group_Details:{},
  Group_Users:[],
  Group_Bots:[],
  loading:false,
  errorMsg:null,
  Token_Used_By_Group:null,
  Group_User_Details_List:[],
  Group_User_Logs:{},
  Group_User_Logs_Loading:true
};

const Owner_Group = createSlice({
  name: "Owner_Group",
  initialState,
  reducers: {

    set_Token_Used_By_Group(state,action){
          state.Token_Used_By_Group = action.payload
    },
    set_Token_Used_By_Group_Failed(state,action){
      state.loading = false;
    },
    set_group_user_details(state,action){
      state.Group_User_Details_List =action.payload
    }
    ,fetchGroup_Details_Success(state, action) {
      const { Group_Details,Group_Users,Group_Bots } = action.payload
      state.Group_Details = Group_Details[0]
      state.Group_Users = Group_Users
      state.Group_Bots = Group_Bots
      state.Token_Used_By_Group = Group_Details.Token_Used
      state.loading = false;
      state.errorMsg = false;
   
    },
    fetchGroup_Details_Failed(state, action) {

      state.loading = false;
      state.errorMsg = action.payload;
      

    },
    reset_group_details_flag(state) {
      state.error = null;
      state.loading = false;
      state.Group_Details = []
      state.Group_Users = []
      state.Group_Bots = []
      localStorage.removeItem('group_id')
    },

    start_group_Deatils_fetch_loading(state, action) {
      state.loading = true;
    },

      stop_group_Deatils_fetch_loading(state, action) {
      state.loading = false;
    },
    set_group_user_log_loading(state,action){
      state.Group_User_Logs_Loading = action.payload
    },
    set_group_user_logs(state,action){
      state.Group_User_Logs = action.payload
    }


  },
});

export const {
  fetchGroup_Details_Success,
  fetchGroup_Details_Failed,
  reset_group_details_flag,
  start_group_Deatils_fetch_loading,
  set_Token_Used_By_Group,
  set_Token_Used_By_Group_Failed,
  set_group_user_details,
  stop_group_Deatils_fetch_loading,
  set_group_user_log_loading,
  set_group_user_logs
} = Owner_Group.actions

export default Owner_Group.reducer;